import techContent from '@content/techstack.yaml'
import type { TechStackContent } from '@/types/content'

const content = techContent as unknown as TechStackContent

export function TechStack() {
  return (
    <section className="ss" style={{ paddingBottom: '4rem' }}>
      <div className="ey reveal">{content.eyebrow}</div>
      <h2 className="sh2 reveal d2" dangerouslySetInnerHTML={{ __html: content.headline }} />
      <div className="tech-mq reveal d3">
        <div className="tech-row">
          {[...content.row1, ...content.row1].map((tech, i) => <span key={`a${i}`} className="tech-pill">{tech}</span>)}
        </div>
        <div className="tech-row rev">
          {[...content.row2, ...content.row2].map((tech, i) => <span key={`b${i}`} className="tech-pill">{tech}</span>)}
        </div>
      </div>
    </section>
  )
}
